import { render, staticRenderFns } from "./IndexBackup.vue?vue&type=template&id=c0937696&"
import script from "./IndexBackup.vue?vue&type=script&lang=js&"
export * from "./IndexBackup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports